<!--
 * @Author: your name
 * @Date: 2020-11-11 21:44:06
 * @LastEditTime: 2020-11-11 22:20:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \insurance-h5\src\views\Login\Login.vue
-->
<template>
<div></div>
</template>

<script>
import {
    getLogin
} from '../../api/api'
import {
    Toast
} from 'vant'
import {
    baseConfig
} from '../../utils/request'
export default {
    data() {
        return {
            query: "",
            newQuery: ""
        };
    },
    mounted() {
        this.query = this.getQuery(window.location.search.split("?")[1], true);
        this.newQuery = this.getQuery(decodeURIComponent(this.query.state).split("?")[1], true) || {};
        this.getRequest();
    },
    methods: {
        // 获取参数的方法
        getQuery(queryString, type) {
            if (!queryString) return;
            var str = type ? "&" : "*";
            var str1 = type ? "=" : "-";
            let result = queryString.split(str);
            result = result.reduce(function (memo, item) {
                item = item.split(str1);
                if (item.length == 2) {
                    memo[item[0]] = item[1];
                }
                return memo;
            }, {});
            return result;
        },
        async getRequest() {
            Toast.loading({
                message: '登录中',
                forbidClick: true,
                duration: 0,
                loadingType: 'spinner'
            })
            const data = await getLogin({
                code: this.query.code,
                channelId: this.newQuery.channelId,
                customerId: this.newQuery.customerId,
                province: this.newQuery.province,
                city: this.newQuery.city
            })
            Toast.clear()
            if (data.success) {
                location.replace(location.origin + decodeURIComponent(this.query.state))
            }
        }
    }
}
</script>

<style>
</style>
